export const homePageRoute = '/';
export const contactPageRoute = '/contact';
export const privacyPolicyPageRoute = '/privacy-policy';
export const termsAndConditionsPageRoute = '/terms-and-conditions';
